<script>
import NewBaremModal from "@/view/pages/test-input/components/ComponentMarkTheExam/NewBaremModal.vue";

export default {
  name: "CriteriaBlock",
  components: {NewBaremModal},
  props: {
    criterion: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {}
  },
  mounted() {
    if(this.criterion.point === 0){
      this.criterion.point = null
    }
  },
  methods: {
    openModalBarem(name = '') {
      this.$bvModal.show('ModalBarem' + name)
    }
  },
  computed: {
    autoComment() {
      return this.criterion?.pointList?.find(item => item?.band === +this.criterion?.point)?.eComment ?? ''
    },
    isAIMark() {
      return this.criterion?.isAIMark ?? false
    }
  }
}
</script>

<template>
  <div style="background-color: #F8F8F8" class="px-4 py-5">
    <div style="background-color: #FF9393;border-radius: 5px; width: fit-content;font-size: 12px;font-weight: 600"
         class="py-1 px-2">
      {{ criterion?.eName }}
    </div>
    <div class="mt-6 d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <ValidationProvider name="Điểm" rules="required" v-slot="{ errors,classes }"
                            :vid="criterion?.eName+'diem'">
          <p class="mb-0">Điểm tiêu chí: <span style="color: red">*</span></p>
          <el-select size="small" placeholder="Chọn điểm" v-model="criterion.point" class="ml-2" style="width: 180px" >
            <el-option
                v-for="item in criterion.pointList"
                :key="item.band"
                :label="item.band"
                :value="item.band">
            </el-option>
          </el-select>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
      </div>
      <p class="mb-0 text-white badge badge-danger" style="font-size: 13px; background-color: #287EFF;
; height: 50%; cursor: pointer; border-radius: 3px" @click="openModalBarem(criterion?.eName)" >
        Chấm theo barem</p>
    </div>
    <div class="mt-6">
      <p>Nhận xét tự động: </p>
      <el-input
          :value="autoComment"
          style="width: 100%"
          :rows="2"
          type="textarea"
      />
    </div>
    <div class="mt-6">
      <ValidationProvider name="Nhận xét cụ thể" rules="required" v-slot="{ errors,classes }"
                          :vid="criterion.eName+'nhaan xet'">
        <p>Nhận xét cụ thể, dẫn chứng: <span style="color: red">*</span></p>
        <el-input
            v-model="criterion.specificComment"
            style="width: 100%"
            :rows="2"
            type="textarea"
            
        />
        <div v-if="!isAIMark" class="d-flex align-items-center mt-2" style="color: #0b1a45; font-weight: 600; font-size: 13px;">
          <svg style="margin-right: 6px;" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.5 2.5L13.2 8.8L19.5 10.5L13.2 12.2L11.5 18.5L9.8 12.2L3.5 10.5L9.8 8.8L11.5 2.5Z" fill="#5e2b9c"/>
            <path d="M19.5 15.5L20.3 18.3L23.1 19.1L20.3 19.9L19.5 22.7L18.7 19.9L15.9 19.1L18.7 18.3L19.5 15.5Z" fill="#5e2b9c"/>
          </svg>
          Nhận xét này được AI gợi ý, bạn có thể chỉnh sửa nếu cần
        </div>
        <div class="fv-plugins-message-container">
          <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
        </div>
      </ValidationProvider>
    </div>
    <NewBaremModal :barem="criterion?.pointList" :name="criterion?.eName" :criterion="criterion"></NewBaremModal>
  </div>
</template>

<style scoped>

</style>